import React from "react";
import { getColorByName, getInitialAvatarJSX } from "../../utils/stringUtils.js";

const UserAvatar = ({ user, size = 45 }) => {
    const hasRealPhoto = !!user?.urlphoto && user.urlphoto !== 'Avatar.png'
    const firstName = user?.firstName || user?.name?.split(' ')[0] || '';
    const lastName = user?.lastName || user?.name?.split(' ').pop() || '';


    // Si urlphoto est valide → afficher image
    if (hasRealPhoto) {
        return (
            <img
                src={user.urlphoto}
                alt={user.name}
                style={{
                    width: size,
                    height: size,
                    borderRadius: (size / 3.75) + "%",
                    objectFit: "cover",
                }}
            />
        );
    }

    // Sinon → cercle + initiales
    return (
        <div
            style={{
                borderRadius: (size / 3.75) + "%",
                userSelect: "none",
                overflow: "hidden",
            }}
        >
            {
                getInitialAvatarJSX(firstName, lastName, {}, size)
            }
        </div>
    );
};

export default UserAvatar;